import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 512.001 512.001"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M345.075 126.02V69.268c0-8.894-7.21-16.104-16.104-16.104H183.029c-8.894 0-16.104 7.21-16.104 16.104v56.752h-45.663v332.818h269.475V126.02zm-32.208-.128H199.133v-40.52h113.733v40.52zM54.741 126.02C24.557 126.02 0 150.576 0 180.76v223.337c0 30.183 24.557 54.74 54.741 54.74h34.313V126.02zM457.26 126.02h-34.313v332.818h34.313c30.184 0 54.741-24.557 54.741-54.74V180.76c-.001-30.184-24.558-54.74-54.741-54.74" }, null, -1)
  ]))]))
}
export default { render: render }